import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef } from "@angular/core";
declare var jQuery: any;
import "../../../../assets/semantic/semantic.min.js";
import { FormGroup, FormControl } from "@angular/forms";
import { ToastService } from "../../../_services/toast.service";
import { PlanningMessagesService } from "../../../_services/planning-messages.service";
import * as moment from 'moment';

@Component({
  selector: "app-planning-chat-modal",
  templateUrl: "./planning-chat-modal.component.html",
  styleUrls: ["./planning-chat-modal.component.css"],
})

export class PlanningChatModalComponent implements OnInit {
  
  @Output() updatePlanningChatData: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild('scrollContainer') private scrollContainer: ElementRef;
  @ViewChild('planning_chat_input') private planning_chat_input: ElementRef;
  moment = moment;
  private planning;
  private user_id;
  private planning_messages: Array<Object> | null = null;
  private getPlanningMessagesLoading: boolean = false;
  private getPlanningMessagesError: boolean = false;
  private sendPlanningMessageLoading: boolean = false;
  
  planning_chat_form = new FormGroup({
    new_message: new FormControl(),
  });

  constructor(
    private toast: ToastService,
    private planningMessagesService: PlanningMessagesService
  ) { }

  ngOnInit() {}

  // Get planning messages
  async getPlanningMessages() {
    this.getPlanningMessagesLoading = true;

    this.planningMessagesService.getPlanningMessages(this.planning.id).subscribe(
      (response) => {
        //console.log("this.planningMessagesService.getPlanningMessages response:", response);
        this.planning_messages = response;
        this.getPlanningMessagesError = false;
        this.getPlanningMessagesLoading = false;
        this.scrollToChatBottom();
        this.focusNewMessageInput();
        this.updatePlanningChatData.emit(this.planning.id);
      },
      (error) => {
        console.log("this.planningMessagesService.getPlanningMessages error:", error);
        this.toast.error(
          error.error && error.error.message 
            ? error.error.message 
            : `Une erreur est survenue lors de la récupération des messages du planning.`,
          false,
          "Récupération des messages"
        );
        this.getPlanningMessagesError = true;
        this.getPlanningMessagesLoading = false;
      }
    );
  }

  // Send planning message
  sendPlanningMessage(message) {
    var body = {
      planning_id: this.planning.id,
      message: message
    };
     
    this.sendPlanningMessageLoading = true;
  
    this.planningMessagesService.sendPlanningMessage(body).subscribe(
      (response) => {
        //console.log("this.planningMessagesService.sendPlanningMessage response:", response);
        this.planning_messages.push(response);
        this.scrollToChatBottom();
        this.planning_chat_form.get('new_message').reset();
        this.sendPlanningMessageLoading = false;
        this.updatePlanningChatData.emit(this.planning.id);
      },
      (error) => {
        console.log("this.planningMessagesService.sendPlanningMessage error:", error);
        this.toast.error(
          error.error && error.error.message 
            ? error.error.message 
            : `Une erreur est survenue lors de l'envoi de votre message.`,
          false,
          "Envoi d'un message"
        );
        this.sendPlanningMessageLoading = false;
      }
    );
  }
  
  scrollToChatBottom() {
    setTimeout(() => {
      this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
    }, 250);
  }

  focusNewMessageInput() {
    setTimeout(() => {
      this.planning_chat_input.nativeElement.focus();
    }, 750);
  }

  // Reset planning chat modal
  resetPlanningChatModal() {
    this.planning_messages = null;
    this.getPlanningMessagesLoading = false;
    this.getPlanningMessagesError = false;
    this.sendPlanningMessageLoading = false;
    this.planning_chat_form.get('new_message').reset();
  }

  // Open modal
  openModal(planning) {
    this.resetPlanningChatModal();
    this.planning = planning;
    this.user_id = localStorage.getItem("current_user_id");
    this.getPlanningMessages();
    jQuery('#planning_chat_modal').modal('show');
  }

  // Close modal
  closeModal() {
    jQuery('#planning_chat_modal').modal('hide');
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/planning/planning-chat-modal/planning-chat-modal.component.ts